module.exports = __webpack_public_path__ + "static/media/animal-cat3.d3ec2f68.aac";